<template>
  <div>
    <!--loader start-->
    <div class="loader-wrapper" v-if="loading">
      <div class="loader">
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
      </div>
    </div>
  <!--loader end-->
  <header v-if="!loading" class="event loding-header nav-abs custom-scroll nav-lg" style="position: relative;padding: 2px">
      <div class="container">
          <div class="row">
              <div class="col">
                  <nav>
                    <a class="d-inline-block m-r-auto" href="">
                        <router-link to="/"><img style="max-width:57px" alt="" class="img-fluid" src="../../theme-assets/images/logo/8.png"></router-link>
                      </a>
                      <!-- <a class="d-inline-block m-r-auto" href="">
                        <router-link to="/"><img style="max-width:55px" alt="" class="img-fluid" src="../../theme-assets/images/logo/cu_logo.png"></router-link>
                      </a> -->
                      <p class="d-inline-block m-auto kalpurush" style="color:black;line-height:19px;    font-family: 'kalpurush'"><!--
                        "শিক্ষা নিয়ে গড়ব দেশ <br> শেখ হাসিনার বাংলাদেশ"-->
                      </p>
                      <a class="d-inline-block m-l-auto" href="">
                        <!--router-link to="/">
                          <img style="max-width:91px" alt="" class="img-fluid" src="../../theme-assets/images/logo/mujib.png">
                        </router-link-->
                      </a>
                      <!-- <div class="navbar m-l-auto" id="togglebtn">
                          
                      </div> -->
                  </nav>
              </div>
          </div>
      </div>
  </header>
  <!--sponsor section start-->
  <section v-if="!loading" class="event about set-relative" style="padding:21px 0px 17px 0px;background-color: #800000;">
      <div class="container set-margin">
          <div class="row">
              <div class="col-md-10 offset-md-1">
                  <div class="cu-header-with-logo">
                      <router-link to="/">
                          <img src="../../theme-assets/images/logo/8.png" alt="CU Logo" class="cu-header-logo">
                      </router-link>
                      <div class="cu-header-title-block">
                          <div class="title title3" style="margin-bottom:0px">
                              <div class="main-title" style="margin-bottom:10px">
                                  <h2 class="text-white" style="font-size:calc(20px + (40 - 30) * ((100vw - 300px) / (1920 - 300)));font-family: 'kalpurush'">চট্টগ্রাম বিশ্ববিদ্যালয়</h2>
                              </div>
                              <div class="sub-title">
                                  <p class="text-white" style="font-family: 'kalpurush'">১ম বর্ষ স্নাতক (সম্মান) ভর্তি পরীক্ষা, শিক্ষাবর্ষঃ ২০২৫-২০২৬</p>
                              </div>
                          </div>
                      </div>
                  </div>
              </div>
          </div>
      </div>
  </section>
  <hr style="margin:0px" v-if="!loading">
  <header v-if="!loading" class="event bg loding-header nav-abs custom-scroll nav-lg" style="position: relative;padding: 0px;background-color:#f9e7d0">
      <div class="container">
          <div class="row">
              <div class="col">
                  <nav>
                      <div class="responsive-btn">
                          <a class="toggle-nav" @click="showMobileSide()">
                              <i style="color:#6997aa !important" class="fa fa-bars"></i>
                          </a>
                      </div>
                      <div class="navbar m-auto" id="togglebtn">
                          <div class="responsive-btn">
                              <a class="btn-back" @click="hideMobileSide()">
                                  <h5>back</h5>
                              </a>
                          </div>
                          <ul class="main-menu">
                            <li>
                              <router-link to="/" style="padding:0px 15px;font-size:24px;font-weight:bold;color:rgb(101 139 148);">
                                <i class="fa fa-home m-r-5"></i>
                              </router-link>    
                            </li>
                            <li @mouseover="showUl('generalInstruction')" @mouseleave="hideUl('generalInstruction')">
                              <a class="dropdown" style="padding:5px 18px;font-size:19px;font-weight:bold;color:rgb(101 139 148);font-family: 'kalpurush'" href="#">সাধারণ নির্দেশনা</a>
                                <ul id="generalInstruction">
                                  <li><router-link to="/prospectus" style="font-family: 'kalpurush'" target="_blank">প্রসপেক্টাস</router-link></li>
                                  <li><router-link to="/admission-circular" style="font-family: 'kalpurush'" target="_blank">ভর্তি বিজ্ঞপ্তি</router-link></li>
                                  <li><router-link to="/application-process" style="font-family: 'kalpurush'" target="_blank">আবেদন প্রক্রিয়া</router-link></li>    
                                </ul>
                            </li>
                              <li @mouseover="showUl('admissionInformation')" @mouseleave="hideUl('admissionInformation')">
                                <a class="dropdown" style="padding:5px 18px;font-size:19px;font-weight:bold;color:rgb(101 139 148);font-family: 'kalpurush'" href="#"> ভর্তি সংক্রান্ত তথ্য</a>
                                  <ul id="admissionInformation"> 
                                    <li><router-link to="/general-qualifications" style="font-family: 'kalpurush'" target="_blank">সাধারণ যোগ্যতা</router-link></li>
                                    <li><router-link to="/schedule" style="font-family: 'kalpurush'" target="_blank">সময়সূচী</router-link></li>
                                    <li><router-link to="/fee-payment-rules" style="font-family: 'kalpurush'" target="_blank">ফি প্রদানের নিয়মাবলী</router-link></li>
                                    <!-- 
                                    <li><router-link to="/thematic-qualifications" target="_blank">বিষয়ভিত্তিক যোগ্যতা</router-link></li> -->
                                    <!-- <li><router-link to="/seat-plan" target="_blank">আসন বিন্যাস</router-link></li> -->
                                    <!-- <li><router-link to="/admission-test-result" target="_blank">ভর্তি পরিক্ষার ফলাফল</router-link></li> -->
                                  
                                  </ul>
                              </li>
                              <li>
                                  <!-- <router-link style="padding:5px 18px;font-size:19px;font-weight:bold;color:rgb(101 139 148)" to="/admission-notice"> নোটিশ বোর্ড </router-link> -->
                                  <router-link style="padding:5px 18px;font-size:19px;font-weight:bold;color:rgb(101 139 148);font-family: 'kalpurush'" to="/notice"> নোটিশ বোর্ড </router-link>
                              </li>
                              <li v-if="isLoggedIn" @mouseover="showUl('profileMenu')" @mouseleave="hideUl('profileMenu')">
                                  <a class="dropdown" style="padding:5px 18px;font-size:19px;font-weight:bold;color:rgb(101 139 148);" href="#">
                                    <i class="fa fa-user-o m-r-5"></i>
                                  </a>
                                  <ul id="profileMenu">
                                    <li><router-link to="/profile" style="font-family: 'kalpurush'">প্রোফাইল</router-link></li>
                                    <li><a @click="logoutHandler" style="font-family: 'kalpurush'">লগ-আউট</a></li>
                                  </ul>
                              </li>
                              <!--<li v-else>
                                  <router-link to="/login" style="padding:5px 18px;font-size:19px;font-weight:bold">
                                    লগইন করুন
                                  </router-link>
                              </li> -->
                              
                          </ul>
                      </div>
                  </nav>
              </div>
          </div>
      </div>
  </header>


<!--sponsor section end-->
    <!--header class="event loding-header nav-abs custom-scroll nav-lg" style="position: relative;padding: 0px">
      <div class="container">
          <div class="row">
              <div class="col">
                  <nav>
                      <a class="d-inline-block m-r-auto" href="">
                        <router-link to="/"><img alt="" class="img-fluid" src="../../theme-assets/images/logo/cu_logo_title.png"></router-link>
                      </a>
                      <div class="responsive-btn">
                          <a class="toggle-nav" @click="showMobileSide()">
                              <i style="color:#6997aa !important" class="fa fa-bars"></i>
                          </a>
                      </div>
                      <div class="navbar m-l-auto" id="togglebtn">
                          <div class="responsive-btn">
                              <a class="btn-back" @click="hideMobileSide()">
                                  <h5>back</h5>
                              </a>
                          </div>
                          <ul class="main-menu">
                              <li @mouseover="showUl('generalInstruction')" @mouseleave="hideUl('generalInstruction')">
                                <a class="dropdown" style="color: #000" href="#"> সাধারণ নির্দেশনা </a>
                                  <ul id="generalInstruction">
                                      <li><router-link to="/prospectus">প্রসপেক্টাস</router-link></li>
                                      <li><router-link to="/addmission-circular">ভর্তি সার্কুলার</router-link></li>
                                      <li><router-link to="/application-process">আবেদন প্রক্রিয়া</router-link></li>
                                      
                                  </ul>
                              </li>
                              <li @mouseover="showUl('admissionInformation')" @mouseleave="hideUl('admissionInformation')">
                                <a class="dropdown" style="color: #000" href="#"> ভর্তি সংক্রান্ত তথ্য</a>
                                  <ul id="admissionInformation"> 
                                    <li><a href="#">সাধারণ যোগ্যতা</a></li>
                                    <li><a href="#"> বিষয়ভিত্তিক যোগ্যতা</a></li>
                                    <li><router-link to="/schedule">সময়সূচী</router-link></li>
                                    <li><router-link to="/fee-payment-rules">ফি প্রদানের নিয়মাবলী</router-link></li>
                                    <li><a href="#">আসন বিন্যাস</a></li>
                                    <li><a href="#">ভর্তি পরিক্ষার ফলাফল</a></li>
                                    
                                  </ul>
                              </li>
                              <li>
                                  <router-link style="color: #000" to="/notice"> নোটিশ বোর্ড </router-link>
                              </li>
                              <li v-if="isLoggedIn" @mouseover="showUl('profileMenu')" @mouseleave="hideUl('profileMenu')">
                                  <a class="dropdown" style="color: #000" href="#">
                                    <i class="fa fa-user-o m-r-5"></i>
                                  </a>
                                  <ul id="profileMenu">
                                    <li><router-link to="/profile">প্রোফাইল</router-link></li>
                                    <li><a @click="logoutHandler">লগ-আউট</a></li>
                                  </ul>
                              </li>
                              <li v-else>
                                  <router-link to="/login" style="color: #000">
                                    লগইন করুন
                                  </router-link>
                              </li>
                              
                          </ul>
                      </div>
                  </nav>
              </div>
          </div>
      </div>
    </header--> 

    <!-- <b-navbar toggleable="md" variant="faded" type="light" sticky>
      
      <button
        v-if="isOnDashboard"
        type="button"
        class="mobileViewHidden collapseButton"
        @click="collapse"
      >
        <span
          class="fa fa-align-justify"
          style="font-size:24px; color: #fff;"
        ></span>
      </button>
     

      <b-navbar-brand to="/">
        <img
          src="https://iitcontent.com/logos/logo.svg"
          class="img-fluid"
          alt="Logo"
        />
      </b-navbar-brand>

     
      <b-navbar-toggle
        v-if="!isOnDashboard && isLoggedIn"
        target="nav_collapse"
      >
      </b-navbar-toggle>
      
      <b-collapse id="nav_collapse" is-nav>
        
        <b-navbar-nav class="ml-auto">
          <b-nav-item v-if="!isOnDashboard && !isOnHomepage" to="/"
            >Home
          </b-nav-item>

          <b-nav-item v-if="!isLoggedIn" to="/login">Login </b-nav-item>
          <b-nav-item v-if="!isLoggedIn" to="/register">Register </b-nav-item>
          <b-nav-item v-if="isOnDashboard && isLoggedIn" :to="{ name: 'home' }">
            <b-button size="sm" class="btn-warning my-2 my-sm-0">
              <i class="fa fa-angle-double-left"></i> Back To External Site
            </b-button>
          </b-nav-item>

          
          <b-nav-item-dropdown
            v-if="isLoggedIn"
            :text="userName"
            :style="{ color: '#ffffff' }"
            class="text-success"
            right
          >
            <b-dropdown-item @click="logoutHandler">
              <i class="fa fa-sign-out"></i> Logout
            </b-dropdown-item>
          </b-nav-item-dropdown>
          

          <b-nav-item
            v-if="!isOnDashboard && isLoggedIn"
            :to="{ name: 'dashboard' }"
          >
            <b-button size="sm" class="btn-warning my-2 my-sm-0">
              Dashboard
            </b-button>
          </b-nav-item>
        </b-navbar-nav>
      </b-collapse>
      
      
      <b-navbar-toggle v-if="isOnDashboard" target="side_nav_collapse">
      </b-navbar-toggle>
    </b-navbar>
    <div
      v-if="!isOnDashboard && !isOnHomepage"
      style="margin-bottom:100px"
    ></div> -->
  </div>
</template>
<script>
import { logout } from '../../utils/Auth'
// import { GET_DOCS } from '../../const/api'
// import { GET } from '../../utils/Request'
export default {
  name: 'Navbar',
  data() {
    return {
      isCollapsed : false,
      fullscreen : false,
      loading : false
    }
  },
  computed: {
    isOnDashboard() {
      let path = this.$route.path
      return path.startsWith('/dashboard')
    },
    isOnHomepage() {
      let routeName = this.$route.name
      return routeName == 'home' ? true : false
    },
    isLoggedIn() {
      if (
        this.$store.state.auth.token &&
        this.$store.state.auth.expiresIn > this.$moment().unix()
      ) {
        return true
      } else {
      //  this.$router.push('/')

        return false
      }
    },
    userName() {
      return this.$store.getters.getUser != null
        ? this.$store.getters.getUser.name
        : ''
    }
  },
  mounted(){
  },
  methods: {
    async logoutHandler() {
      // this.$router.push('/')
      await logout()
    },
    collapse() {
      if (this.isCollapsed === true) {
        this.isCollapsed = false
      } else {
        this.isCollapsed = true
      }
      this.$emit('update')
    },
    showUl(name){
      document.getElementById(name).style.display = "block";
    },
    hideUl(name){
      document.getElementById(name).style.display = "none";
    },
    showMobileSide(){
      //document.getElementById("togglebtn").style.right = ''+(window.innerWidth/2)+'px';
      document.getElementById("togglebtn").style.right = '0px';
    },
    hideMobileSide(){
      document.getElementById("togglebtn").style.right = "-350px";
    }
  }
}
</script>

<style>
.kalpurush{
     font-family: "kalpurush", Helvetica, Arial;
  }
/* .collapseButton {
  margin-right: 20px;
  border: transparent;
  background: transparent;
} */
/* .navbar { */
  /* background-color: #003c6f; */
  /* -webkit-box-shadow: 0px 5px 20px 0px #a29a9a; */
  /* -moz-box-shadow: 0px 5px 20px 0px #a29a9a; */
  /* -ms-box-shadow: 0px 5px 20px 0px #a29a9a; */
  /* -o-box-shadow: 0px 5px 20px 0px #a29a9a; */
  /* box-shadow: 0px 5px 20px 0px #a29a9a; */
  /* margin-bottom: 15px; */
/* } */

/* .navbar-brand img {
  width: 290px;
}
.navbar-toggler {
  color: rgba(0, 0, 0, 0.5);
  border-color: rgba(0, 0, 0, 0.1);
}

.navbar-light .navbar-nav .nav-link {
  color: #ffffff !important;
}

.navbar-light .navbar-nav .nav-link.dropdown-toggle::after {
  border-top-color: red !important;
}

@media (min-width: 769px) {
  .sticky-top {
    position: fixed;
    width: 100%;
  }
}

@media screen and (max-width: 600px) {
  .mobileViewHidden {
    visibility: hidden;
    clear: both;
    float: left;
    margin: 10px auto 5px 20px;
    width: 28%;
    display: none;
  }
} */
.img-fluid {
  max-width: 100%;
}
</style>
